import { createStyled } from "@mui/system";
import theme from "../theme";

const useStyled = () => {
  const styled = createStyled({ defaultTheme: theme });

  return { theme, styled };
};

export default useStyled;
